<div #TransferModalDiv data-cy="transfer-modal">
    <ngx-smart-modal #TransferModal
        [identifier]="modalType"
        [title]="modalTitle"
        [closeButtonText]="closeButtonText"
        [confirmButtonText]="confirmButtonText"
        [disableConfirmButton]="disableConfirmButton">

        <div class="transfer-modal-body">
            
            <!-- Resource Name -->
            <div class="resource-name-section">
                <div class="resource-name-value">{{ resourceName }}</div>
            </div>

            <!-- Transfer mode radio selection -->
            <div *ngIf="showTransferModeSection" class="transfer-mode-section">
                <label>Transfer To</label>
                <lib-radio-checkbox-list
                    type="radio"
                    name="transferMode"
                    [options]="transferModeOptions"
                    valueProperty="value"
                    labelProperty="text"
                    [formControl]="transferModeControl">
                </lib-radio-checkbox-list>
            </div>

            <!-- Myself: domain selection + optional message -->
            <div *ngIf="transferMode === TransferMode.MYSELF" class="self-transfer-section">

                <div class="domain-selection-section">
                    <label class="section-label">Select Target Domain</label>
                    <lib-radio-checkbox-list
                        type="radio"
                        name="targetDomain"
                        [options]="domainOptions"
                        valueProperty="value"
                        labelProperty="text"
                        [formControl]="domainControl">
                    </lib-radio-checkbox-list>
                </div>
            </div>

            <!-- Another user: use existing lib-share-data -->
            <lib-share-data
                [ngClass]="{'cross-domain-data-section': transferMode !== TransferMode.ANOTHER_USER}"
                [projectTitle]=""
                [inputLabel]="inputLabel"
                [inputPlaceholder]="inputPlaceholder"
                [optionalMessageLabel]="optionalMessageLabel"
                [optionalMessagePlaceholder]="optionalMessagePlaceholder"
                [allowAddUser]="false"
                [alertMsg]="alertMessage"
                [errorMsg]="errorMsg?.toString()"
                (outputDataChange)="dataChanged($event)">
            </lib-share-data>

        </div>

    </ngx-smart-modal>
</div>
